import {post} from './http'
const baseUrl = '/api/capwhale/'

// 查询会员开通收费会员的情况，支持未登录的情况
export const queryCustomerFeeInfo = v => post(`${baseUrl}pay/queryCustomerFeeInfo`, v.data, v.success, v.error)
// 查询会员交费支付结果，收银台支付完成后回调页面调用该接口
export const queryCustomerFeeOrderPayResult = v => post(`${baseUrl}pay/queryCustomerFeeOrderPayResult`, v.data, v.success, v.error)
// 提交会员交费支付请求
export const uploadCustomerFeeOrder = v => post(`${baseUrl}pay/uploadCustomerFeeOrder`, v.data, v.success, v.error)